var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import './WorkspaceHeaderStyles.scss';
// Side-effect import — keeps `header__field` / `header__label` rules in the
// bundle whenever this header is mounted, even if a consumer renders raw
// markup instead of the `HeaderField` component.
import '../HeaderField/HeaderFieldStyles.scss';
/**
 * Workspace Header Component
 * Page-level header anchored to the top of a workspace view.
 * @version 1.0.0
 * @since 2026-04-09
 */
export const WorkspaceHeader = forwardRef((_a, ref) => {
    var { title, contextLabel, contextHref, divider = true, sticky = false, actions, fields, subtitle, className = '' } = _a, props = __rest(_a, ["title", "contextLabel", "contextHref", "divider", "sticky", "actions", "fields", "subtitle", "className"]);
    const rootClass = 'qmb-ui-header';
    const typeClass = `${rootClass}--workspace`;
    const stickyClass = sticky ? `${rootClass}--sticky` : '';
    const combinedClass = [rootClass, typeClass, stickyClass, className].filter(Boolean).join(' ');
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("header", Object.assign({ ref: ref, role: "banner", "aria-label": title, className: combinedClass }, props),
        React.createElement("div", { className: "header__row" },
            React.createElement("div", { className: "header__heading" },
                React.createElement("h1", { className: "header__title" },
                    React.createElement("span", { className: "header__title-text" }, title),
                    contextLabel && React.createElement("a", { className: "header__context", href: contextHref }, contextLabel)),
                subtitle && React.createElement("p", { className: "header__subtitle" }, subtitle)),
            actions && (React.createElement("nav", { className: "header__actions", "aria-label": "Workspace actions" }, actions))),
        fields && (React.createElement("div", { className: "header__row", role: "group", "aria-label": "Workspace fields" }, fields)),
        divider && React.createElement("hr", { className: "header__divider", "aria-hidden": "true" })));
});
WorkspaceHeader.displayName = 'WorkspaceHeader';
